import { IWarboxConversationInitialContext } from '../types';
import { DEFAULT_WARBOX_CONVERSATION_STATE } from './defaultState';

export const DEFAULT_WARBOX_CONVERSATION_CONTEXT: IWarboxConversationInitialContext = {
    ...DEFAULT_WARBOX_CONVERSATION_STATE,
    clearState: () => {},
    setLoading: () => {},
    getConversation: async () => undefined,
    getConversations: async () => undefined,
    updateConversation: async () => undefined,
    deleteConversation: async () => undefined,
    upsertConversation: () => {},
};
